import React from 'react';

export interface PreviewData {
  name: string;
  organization: string;
  course: string;
  date: string;
  duration?: string;
  city?: string;
  hash?: string;
}

export const formatDate = (value?: string) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const CertificatePreview: React.FC<{ data: PreviewData }> = ({ data }) => {
  const meta = [data.duration && `${data.duration} hours`, data.city, formatDate(data.date)].filter(Boolean).join(' · ');
  return (
    <div className="cert-preview">
      <div className={`cert-org${data.organization ? '' : ' ph'}`}>{data.organization || 'Organization'}</div>
      <div className="cert-sm">certifies that</div>
      <div className={`cert-name${data.name ? '' : ' ph'}`}>{data.name || 'Recipient name'}</div>
      <div className="cert-sm">has completed</div>
      <div className={`cert-course${data.course ? '' : ' ph'}`}>{data.course || 'Course name'}</div>
      <div className="cert-sm">{meta || 'Date and city'}</div>
      <div className="cert-foot">
        <span>Basma verified</span>
        <span>{data.hash || 'hash generated on issue'}</span>
      </div>
    </div>
  );
};

export default CertificatePreview;
